export const data = [
	{
		title: 'about',
		list: [
			{
				text: 'about',
				subText: 'title',
				goTo: '/',
			},
			{
				text: 'announcements',
				goTo: 'notifications',
			},
		],
	},
	{
		title: 'services',
		list: [
			{
				text: 'audit',
				goTo: 'settings',
			},
		],
	},
	{
		title: 'support',
		list: [
			{
				text: 'helpCenter',
				goTo: 'notifications',
			},
		],
	},
	{
		title: 'products',
		list: [
			{
				text: 'trade',
				goTo: '/trade/',
			},
			{
				text: 'derivatives',
				goTo: '/trade/',
			},
		],
	},
]
